'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export')
  , $pad    = require('./_string-pad');

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/es7.string.pad-start.js
// module id = 644
// module chunks = 48 49 50 51